/** @format */

import { Box, Text } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { defineTopeteRecomendacao, validaValidadede } from "../../../utils";

export function CardHeader({ descricao, props }) {
  const {
    id_classificacao_topete,
    headerDestaqueStyle = id_classificacao_topete === "1" ||
    id_classificacao_topete === "3"
      ? true
      : false,
    headerText = defineTopeteRecomendacao(id_classificacao_topete),

    validadede,
    validoapartir = validaValidadede({
      validadede: validadede,
    }),
    idtiporecomendacao,
    esgotado = false,
  } = props;

  const {
    personalizacao: { card },
  } = usePersonalizacao();

  const getCorBgDestaque = () => {
    if (idtiporecomendacao === "1") {
      return card?.descontoexclusivo?.cordestaque
        ? card?.descontoexclusivo?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "2") {
      return card?.tabloide?.cordestaque
        ? card?.tabloide?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "3") {
      return card?.cashback?.cordestaque
        ? card?.cashback?.cordestaque
        : card?.cordestaque;
    }
  };
  const getCorTextoDestaque = () => {
    if (idtiporecomendacao === "1") {
      return card?.descontoexclusivo?.cortextodestaque
        ? card?.descontoexclusivo?.cortextodestaque
        : card?.cortextodestaque;
    }
    if (idtiporecomendacao === "2") {
      return card?.tabloide?.cortextodestaque
        ? card?.tabloide?.cortextodestaque
        : card?.cortextodestaque;
    }
    if (idtiporecomendacao === "3") {
      return card?.cashback?.cortextodestaque
        ? card?.cashback?.cortextodestaque
        : card?.cortextodestaque;
    }
  };

  return (
    <>
      {headerDestaqueStyle && headerText ? (
        <Box
          display="flex"
          flexDir="column"
          alignItems="center"
          paddingX="0.5rem"
          paddingY="0.375rem"
          borderTopRadius={descricao ? "none" : "md"}
          background={esgotado || validoapartir ? "#70747D" : getCorBgDestaque}
          borderBottomRadius={descricao ? "none" : "none"}>
          <Text fontSize="0.75rem" color={getCorTextoDestaque}>
            {headerText}
          </Text>
        </Box>
      ) : !headerDestaqueStyle && headerText ? (
        <Box
          display="flex"
          flexDir="column"
          alignItems="center"
          paddingX="0.5rem"
          paddingY="0.375rem"
          borderTopRadius="md"
          borderBottomRadius={descricao ? "sm" : "none"}>
          <Text
            fontSize="0.75rem"
            color={validoapartir || esgotado ? "#70747D" : getCorBgDestaque}>
            {headerText}
          </Text>
          <Box
            position="absolute"
            bottom="0"
            width="90%"
            height="1px"
            background="#D5D8E0"
          />
        </Box>
      ) : (
        <Box
          display="flex"
          flexDir="column"
          alignItems="center"
          paddingX="0.5rem"
          paddingY="0.375rem"
          borderTopRadius="md">
          <Text fontSize="0.75rem" color={getCorBgDestaque} visibility="hidden">
            ⠀
          </Text>
        </Box>
      )}
    </>
  );
}
